<template>
	<div class="parts-locations-general-card-edit">
		<!-- Repair Order Section -->
		<SectionContainer>
			<template #left>
				<h4>SMS/Email</h4>
			</template>
			<template #content>
				<Dropdown
					label="Email Provider"
					v-model="localData.repairOrder.emailProvider"
					:options="emailProviderTypeOptions"
				/>
				<Dropdown
					label="SMS Provider"
					v-model="localData.repairOrder.smsProvider"
					:options="smsProviderTypeOptions"
				/>
				<Dropdown
					label="Reply-To Email"
					v-model="localData.repairOrder.replayToEmail"
					:options="replayToEmailTypeOptions"
				/>
			</template>
		</SectionContainer>
		<!-- Repair Order Payment Section -->
		<SectionContainer>
			<template #left>
				<h4>Repair Order Payment</h4>
			</template>
			<template #content>
				<Dropdown
					label="Email Provider"
					v-model="localData.roPayment.emailProvider"
					:options="emailProviderTypeOptions"
				/>
				<Dropdown
					label="SMS Provider"
					v-model="localData.roPayment.smsProvider"
					:options="defaultAccountCodeTypeOptions"
				/>
				<Dropdown
					label="Reply-To Email"
					v-model="localData.roPayment.replayToEmail"
					:options="defaultAccountCodeTypeOptions"
				/>
			</template>
		</SectionContainer>
		<!-- Appointment -->
		<SectionContainer>
			<template #left>
				<h4>Appointment</h4>
			</template>
			<template #content>
				<Dropdown
					label="Email Provider"
					v-model="localData.appointment.emailProvider"
					:options="emailProviderTypeOptions"
				/>
				<Dropdown
					label="SMS Provider"
					v-model="localData.appointment.smsProvider"
					:options="defaultAccountCodeTypeOptions"
				/>
				<Dropdown
					label="Reply-To Email"
					v-model="localData.appointment.replayToEmail"
					:options="defaultAccountCodeTypeOptions"
				/>
			</template>
		</SectionContainer>
	</div>
</template>

<script>
import Dropdown from '@/components/forms/dropdown/dropdown.vue';
import SectionContainer from '@/components/shells/section-container/section-container';
import _ from 'lodash';

export default {
	name: 'PartsLocationsGeneralCardEdit',
	components: { SectionContainer, Dropdown },
	props: {
		value: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			localData: _.cloneDeep(this.value),
			defaultAccountCodeTypeOptions: ['lorem', 'ipsum'],
			emailProviderTypeOptions: ['lorem', 'ipsum'],
			smsProviderTypeOptions: ['lorem', 'ipsum'],
			replayToEmailTypeOptions: ['lorem', 'ipsum']
		};
	},
	created() {
		//console.log(this.value);
	},
	watch: {
		localData: {
			deep: true,
			handler() {
				this.$emit('update', this.localData);
				this.$emit('input', this.localData);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.parts-locations-general-card-edit {
	&__item {
		display: block;
	}
}
</style>
